import type { CoreConsent } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Checkbox,
  CheckboxCheckMark,
} from "@tandemdiabetes/sugarmate-react-components"

import { useCallback } from "react"
import styles from "./ConsentCheckbox.module.scss"
import { ConsentLabel } from "./ConsentLabel"

interface Props {
  consent: CoreConsent;
  checked?: boolean;
  required?: boolean;
  onToggleConsent: (policyId: CoreConsent["policyId"]) => void;
}

export const ConsentCheckbox = (props: Props) => {
  const {
    consent, onToggleConsent, checked = false, required = false,
  } = props

  const onConsentToggle = useCallback(
    () => {
      onToggleConsent(consent.policyId)
    },
    [
      consent,
      onToggleConsent,
    ],
  )

  const ariaLabel = consent.inlineContent
    ? consent.inlineContent.title
    : (consent.content?.text || "").replace(
      "[",
      "",
    ).replace(
      "]",
      "",
    )

  return (
    <div
      className={styles.checkboxContainer}
      data-checked={checked}
    >
      <Checkbox
        className={styles.checkbox}
        htmlFor={consent.policyId}
        checked={checked}
        onChange={onConsentToggle}
        required={required}
        aria-label={ariaLabel}
      >
        <CheckboxCheckMark id={consent.type} />
        <div>
          <ConsentLabel consent={consent} />
        </div>
      </Checkbox>
    </div>
  )
}
